<template>
  <div>
    <div class="scenario-table" :class="{'scenario-table-template': isRoboPartsSetView}">
      <!-- モーダル画面 -->
      <div style="display: flex;">
        <ModalEditScenario :PCTRLLOG="CTRLLOG"></ModalEditScenario>
        <ModalDeleteScenario :PCTRLLOG="CTRLLOG"></ModalDeleteScenario>
        <ModalDeleteNode :PCTRLLOG="CTRLLOG"></ModalDeleteNode>
        <ModalDeleteListScenario :PCTRLLOG="CTRLLOG"></ModalDeleteListScenario>
        <ModalExportListScenario></ModalExportListScenario>
        <ModalImportListScenario></ModalImportListScenario>
        <ModalSettingArguments
          :companyColumnSetting="companyColumnSetting"
          :robo="selectChatbot"
          :PCTRLLOG="CTRLLOG"
        />
        <ModalAllPartsConfirmListScenario :PCTRLLOG="CTRLLOG"></ModalAllPartsConfirmListScenario>
      </div>
      <!-- ヘッダー -->
      <div v-if="isRoboPartsSetView"><b>パーツセットビュー</b><span class="close-button mdi mdi-close-circle mdi-24px" @click="closeRoboPartsSetView()"></span></div>
      <div class="header-scenario" v-if="!isFailedScenario" :class="{'header-scenario-template': isRoboPartsSetView}">
        <div class="header-button-list">
          <b-tooltip label="シナリオを全て削除" position="is-right" type="is-dark" v-if="!isRoboPartsSetView">
            <a @click="openDeleteScenarioList()" v-if="!isRoboPartsSetView && !selectChatbot.is_confirm">
              <span class="mdi mdi-delete mdi-36px"></span>
            </a>
            <a v-if="!isRoboPartsSetView && selectChatbot.is_confirm" style="cursor: not-allowed; color: #E9BDB5;">
              <span class="mdi mdi-delete mdi-36px"></span>
            </a>
          </b-tooltip>
          <b-tooltip label="パーツセットを削除" position="is-right" type="is-dark" v-if="isRoboPartsSetView">
            <a @click="openDeleteScenarioList()" v-if="isRoboPartsSetView">
              <span class="mdi mdi-delete mdi-36px"></span>
            </a>
          </b-tooltip>
          <b-tooltip label="シナリオのパーツセット化" position="is-right" type="is-dark" v-if="!isRoboPartsSetView">
            <a @click="openExportRoboPartsSet()" v-if="!isRoboPartsSetView">
              <span class="mdi mdi-export mdi-36px"></span>
            </a>
          </b-tooltip>
          <b-tooltip label="パーツセットのシナリオ化" position="is-right" type="is-dark" v-if="isRoboPartsSetView">
            <a @click="openImportRoboPartsSet()" v-if="isRoboPartsSetView">
              <span class="mdi mdi-import mdi-36px"></span>
            </a>
          </b-tooltip>
          <b-tooltip label="ロボ引用設定" position="is-right" type="is-dark" v-if="!isRoboPartsSetView">
            <a @click="openSettingArguments()">
              <span class="mdi mdi-comment-plus-outline mdi-36px"></span>
            </a>
          </b-tooltip>
          <div style="margin: 4px; border-left: solid 2px #ddd;"></div>
          <b-tooltip v-show="!isRoboPartsSetView" label="ロボページのリンクを取得" position="is-right" type="is-dark">
            <a @click="getRoboLink(selectChatbot.bot_id)" v-if="selectChatbot.is_confirm">
              <span class="mdi mdi-link-variant mdi-36px"></span>
            </a>
            <a v-if="!selectChatbot.is_confirm" style="cursor: not-allowed; color: #E9BDB5;">
              <span class="mdi mdi-link-variant mdi-36px"></span>
            </a>
          </b-tooltip>
          <div v-show="!isRoboPartsSetView" style="margin: 4px; border-left: solid 2px #ddd;"></div>
          <b-tooltip label="拡大" position="is-right" type="is-dark">
            <a @click="$refs.bp.zoomBtn(0.9)">
              <span class="mdi mdi-magnify-plus mdi-36px"></span>
            </a>
          </b-tooltip>
          <b-tooltip label="縮小" position="is-right" type="is-dark">
            <a @click="$refs.bp.zoomBtn(1.1)">
              <span class="mdi mdi-magnify-minus mdi-36px"></span>
            </a>
          </b-tooltip>
          <div v-if="!isRoboPartsSetView" style="margin: 4px; border-left: solid 2px #ddd;"></div>
          <b-tooltip v-if="!isRoboPartsSetView" label="Undo" position="is-right" type="is-dark">
            <a @click="undoScenario()" v-if="!selectChatbot.is_confirm">
              <span class="mdi mdi-undo mdi-36px"></span>
            </a>
            <a v-if="selectChatbot.is_confirm" style="cursor: not-allowed; color: #E9BDB5;">
              <span class="mdi mdi-undo mdi-36px"></span>
            </a>
          </b-tooltip>
          <b-tooltip v-if="!isRoboPartsSetView" label="Redo" position="is-right" type="is-dark">
            <a @click="redoScenario()" v-if="!selectChatbot.is_confirm">
              <span class="mdi mdi-redo mdi-36px"></span>
            </a>
            <a v-if="selectChatbot.is_confirm" style="cursor: not-allowed; color: #E9BDB5;">
              <span class="mdi mdi-redo mdi-36px"></span>
            </a>
          </b-tooltip>
          <div style="margin: 4px; border-left: solid 2px #ddd;"></div>
        </div>
        <!-- シナリオビュー -->
        <div
          class="header-title"
          style="margin: 4px; align-items: center; text-overflow: ellipsis; overflow: hidden;"
          v-if="!isRoboPartsSetView"
        >
          <p
            @click="openSettingNameModal()"
            style="margin-right: 8px; font-size: 14px; font-weight: bold; white-space: nowrap; cursor: pointer;"
          >
            {{selectChatbot.name}}
          </p>
        </div>
        <!-- パーツセットビュー -->
        <div class="header-title" style="margin: 4px;" v-else>
          <p class="scenario-title" @click.prevent="changeForm(true); clickRoboPartsSetName(selectRoboPartsSet.robo_parts_set_name)" v-if="!isInput">
            <template v-if="roboPartsSetNameBeforeChange == ''">{{ selectRoboPartsSet.robo_parts_set_name }}</template>
            <template v-else>{{roboPartsSetNameBeforeChange}}</template>
          </p>
          <div class="field has-addons" v-if="isInput">
            <div class="control">
              <input class="input"
                @click.prevent="changeForm(true);"
                v-model="selectRoboPartsSet.robo_parts_set_name"
                @keydown.ctrl.enter="saveRoboPartsSetName(selectRoboPartsSet);changeForm(false)"
                @keydown.meta.enter="saveRoboPartsSetName(selectRoboPartsSet);changeForm(false)"
                v-if="isInput">
            </div>
            <div class="control">
              <a class="save-title-button button is-primary"
                @click="saveRoboPartsSetName(selectRoboPartsSet);changeForm(false)"
                v-if="isInput">
                保存
              </a>
            </div>
          </div>
        </div>
        <!-- 使用パーツ数 -->
        <div class="header-status" style="margin: 4px; align-items: center; text-overflow: ellipsis; overflow: hidden;">
          全パーツ数：{{scenarioTable.length}}
        </div>
        <!-- 共同編集者 -->
        <!--
        <div class="header-status" v-if="!isRoboPartsSetView">
          <template v-for="(u, idx) in userList">
            <template v-if="isOnUser(u)">
              <Tooltip :message="u.name + '\n' + u.email">
                <img
                  class="user-icon"
                  :key="idx"
                  :src="u.icon"
                />
              </Tooltip>
            </template>
          </template>
        </div>
        -->
      </div>
      <!-- シナリオブループリント -->

      <!-- rectをホバーした際にパーツ内容が表示 -->
      <div ref="scefl" class="scenario-flow disp-scroll"
        :class="{'on-drop-area': isDrop, 'scenario-flow-height': !isRoboPartsSetView, 'scenario-flow-parts-set-height': isRoboPartsSetView}"
        @dragover="onDragover"
        @drop.prevent="onDrop"
        @click.prevent="changeForm(false)"
        v-if="!isFailedScenario"
        v-dragscroll="{active:isDragScroll}">
        <div class="drop-filter" v-if="isDrop"></div>
        <div class="hukidashi" :class="{'hukidashi-width': !isMenuMiniSize, 'hukidashi-thin-menu-width': isMenuMiniSize}" v-if="detail" :style="getIsUp(detailIsUp)">
          <img style="width: 80px; height: 80px; background: white; border-radius: 50%; margin-left: 20px;" src="@/assets/lp/hrmonster.png"/>
          <div class="message-box">
            <p class="message-detail" v-html="fixURL(detail)"></p>
          </div>
        </div>
        <BluePrint :PCTRLLOG="CTRLLOG" ref="bp"></BluePrint>
      </div>
      <!-- エラーがある場合に表示 -->
      <ScenarioErrorFooter v-if="errorList.length && !detail"
        :isErrorFooter="isErrorFooter"
        :errorItemNumber="errorItemNumber"
        :errorList="errorList"
        :isMenuMiniSize="isMenuMiniSize"
        @change-is-error-footer="changeIsErrorFooter"
        @minus-error-item-number="minusErrorItemNumber"
        @plus-error-item-number="plusErrorItemNumber"/>
      <ContextMenuScenario/>
    </div>
    <!-- Footerボタン表示 -->
    <div class="footer-button">
      <div style="margin-top: 10px; align-items: center;">
        <button class="button mdi mdi-play mdi-24px"
          style="border-color:#C82E42; color:#C82E42; margin-left: 5px;"
          @click="openChatBotPreview(selectChatbot)"
          type="is-dark"
          v-if="!isFailedScenario && !isRoboPartsSetView">
        プレビュー</button>
        <!-- 処理内容が確定していないため、非表示
        <button class="button mdi mdi-checkbox-multiple-marked-outline mdi-24px"
          style="border-color:#C82E42; color:#C82E42; margin-left: 5px;"
          @click="openChatBotPreview(selectChatbot)"
          type="is-dark"
          v-if="!isFailedScenario && !isRoboPartsSetView"
        >
          シナリオ別確認
        </button>
        -->
        <button class="button mdi mdi-checkbox-marked-outline mdi-24px"
          style="border-color:#C82E42; color:#C82E42; margin-left: 5px;"
          @click="changeByParts(scenarioTable)"
          type="is-dark"
          v-if="!isFailedScenario && !isRoboPartsSetView"
        >
          パーツ別確認
        </button>
        <button class="button mdi mdi-lock mdi-24px"
          style="border-color:#C82E42; color:#C82E42; margin-left: 5px;"
          @click="openAllPartsConfirmScenarioList()"
          type="is-dark"
          v-if="!isRoboPartsSetView && searchPartsConfirm(scenarioTable) && checkAuthority()"
        >
          パーツ全確定
        </button>
        <button class="button mdi mdi-lock-open mdi-24px"
          style="border-color:#C82E42; color:#C82E42; margin-left: 5px;"
          @click="openAllPartsConfirmScenarioList()"
          type="is-dark"
          v-if="!isRoboPartsSetView && !searchPartsConfirm(scenarioTable) && !selectChatbot.is_confirm && checkAuthority()"
        >
          パーツ全確定解除
        </button>
        <button class="button mdi mdi-lock-open mdi-24px"
          style="border-color:#C82E42; color:#C82E42; margin-left: 5px;"
          @click="openAllPartsConfirmScenarioList()"
          type="is-dark"
          v-if="!isRoboPartsSetView && !searchPartsConfirm(scenarioTable) && selectChatbot.is_confirm && checkAuthority()" disabled
        >
          パーツ全確定解除
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState }            from 'vuex'
import { dragscroll }          from 'vue-dragscroll'
import draggable               from 'vuedraggable'
import ModalEditScenario       from '@/components/ui/ModalEditScenario'
import ModalDeleteScenario     from '@/components/ui/ModalDeleteScenario'
import ModalDeleteNode         from '@/components/ui/ModalDeleteNode'
import ModalCreateChatBot      from '@/components/ui/ModalCreateChatBot'
import ModalDeleteListScenario from '@/components/ui/ModalDeleteListScenario'
import ModalExportListScenario from '@/components/ui/ModalExportListScenario'
import ModalImportListScenario from '@/components/ui/ModalImportListScenario'
import ModalAllPartsConfirmListScenario from '@/components/ui/ModalAllPartsConfirmListScenario'
import ScenarioErrorFooter     from '@/components/organisms/chatbot/footers/ScenarioErrorFooter'
import Loading                 from '@/components/animations/Loading'
import BluePrint               from '@/views/DashBoard/ChatBot/BluePrint'
import ContextMenuScenario     from '@/components/ui/ContextMenuScenario'
import createUUID              from '@/functions/createUUID'
import Tooltip                 from '@/components/atoms/tooltips/Tooltip'
import ModalSettingArguments   from '@/components/organisms/chatbot/modals/ModalSettingArguments'
import controlLogMixin from '@/mixins/controlLogMixin'
import {
  isRoboDisplayPermission
} from '@/functions/checkPermission'

export default {
  name: 'ScenarioList',
  componentName: 'ScenarioList',
  components: {
    ModalEditScenario,
    ModalDeleteScenario,
    ModalDeleteNode,
    ModalCreateChatBot,
    ModalDeleteListScenario,
    ModalExportListScenario,
    ModalImportListScenario,
    ModalAllPartsConfirmListScenario,
    ScenarioErrorFooter,
    ContextMenuScenario,
    Loading,
    BluePrint,
    draggable,
    Tooltip,
    ModalSettingArguments,
  },
  mixins: [
    controlLogMixin
  ],
  directives: {
    dragscroll
  },
  props: {
    openSettingNameModal: {
      type: Function,
      required: true
    },
  },
  computed: {
    ...mapState('chatbot',  ['scenarioTable', 'chatbots', 'scenarioName', 'isSCNLoading',
                              'isDrop', 'scenarioPartsIndex', 'isFailedScenario', 'isRoboPartsSetView',
                              'selectScenario', 'selectRoboPartsSet', 'dropRoboPartsSet', 'selectChatbot',
                              'detail', 'bluePrintInfoFlg', 'detailIsUp', 'selectScenarioName',
                              'scenarioTitleBeforeChange', 'isPaste', 'isCopy', 'isCut', 'isEndCutDelete',
                              'isEndPaste', 'isDragScroll', 'currentUndoIndex', 'undoData'
                            ]),
    ...mapState('auth',     ['botstatus', 'user', 'users', 'companyColumnSetting']),
    ...mapState('calendar', ['recommendDate']),
    ...mapState('virtualOffice', ['userList', 'makeScenario', 'deleteScenario', 'reloadScenario']),
    ...mapState("setting",["isMenuMiniSize"]),
  },
  data () {
    return {
      isDebug    : false,
      isLoading  : true,
      isAction   : true,
      isInput    : false,
      sWidth     : 0,
      sHeight    : 0,
      isDropModal: false,
      dropPartsSet  : null,
      roboPartsSetName: this.selectRoboPartsSet ? this.selectRoboPartsSet.robo_parts_set_name : '',
      recommendDay: [],
      intervalId: [],
      importNodeX: 0,
      importNodeY: 0,
      roboPartsSetNameBeforeChange: '',
      errorList: [],
      errorItemNumber: 0,
      isErrorFooter: true,
      DisplayName: '',
      isTemplateReturn: false,
      editStartRecord: null,
      recordTimeout: -1,
      everySecond: null,
    }
  },
  watch: {
    errorItemNumber () {
      if (this.errorItemNumber === -1) {
        this.errorItemNumber++
      }
    },
    scenarioTable () {
      this.isLoading = false
      this.$nextTick(() => (this.isLoading = true))
      this.$nextTick(() => (this.isLoading = false))
      this.errorCheck(this.scenarioTable)
    },
    selectScenario () {
      this.roboPartsSetName = this.selectScenario
      let isCopy = Boolean(Number(localStorage.getItem('SCENARIO_IS_COPY')))
      let isCut  = Boolean(Number(localStorage.getItem('SCENARIO_IS_CUT')))
      this.$store.dispatch('chatbot/setPasteFlg', Boolean(isCopy || isCut), isCopy, isCut)
    },
    bluePrintInfoFlg () {
      if (this.bluePrintInfoFlg) {
        var elem = this.$refs.scefl
        var width = elem.clientWidth
        var height = elem.clientHeight
        var scrollX = elem.scrollLeft
        var scrollY = elem.scrollTop
        this.$store.dispatch('chatbot/setBluePrintInfo', {width, height, scrollX, scrollY})
        this.$store.dispatch('chatbot/setBluePrintInfoFlg', false)
      }
    },
    isEndPaste () {
      if (this.isEndPaste && this.isPaste && this.isCut) {
        // Cut前Paste完了
        this.$store.dispatch('chatbot/scenarioCutDelete', this.user.companyID)
      } else if (this.isEndPaste) {
        // Copy & Paste完了
        this.$store.dispatch('chatbot/scenarioCopyClear')
      }
    },
    isEndCutDelete () {
      if (this.isEndCutDelete) {
        // Cut & Paste完了
        this.$store.dispatch('chatbot/scenarioCopyClear')
      }
    },
    userList: {
      handler: function (val, oldVal) {
        this.userList.forEach((obj) => {
          if (obj.editScenario) {
            this.$store.dispatch('chatbot/realtimeSetScenario', obj.editScenario)
          }
        })
      },
      deep: true
    },
    makeScenario () {
      this.$store.dispatch('chatbot/realtimeCreateScenario', this.makeScenario)
      this.$store.dispatch('virtualOffice/resetCreateScenario')
    },
    deleteScenario () {
      if (this.deleteScenario) {
        this.$store.dispatch('chatbot/realtimeDeleteScenario', this.deleteScenario)
        this.$store.dispatch('virtualOffice/resetDeleteScenario')
      }
    },
    reloadScenario () {
      if (this.selectScenarioName) {
        if (this.selectScenarioName === this.reloadScenario) {
          this.$store.dispatch('virtualOffice/resetReloadScenario')
          this.$store.dispatch('chatbot/getScenario',
            {
              companyid   : this.user.companyID,
              scenarioName: this.selectScenarioName
            }
          )
        }
      }
    },
    recordTimeout () {
      if (this.recordTimeout == 0) {
        this.$store.dispatch('chatbot/saveScenarioEditLog', {
          chatbot_id: this.editStartRecord.chatbot_id,
          time_sec: (new Date().getTime() - this.editStartRecord.start.getTime()) / 1000
        })
        this.editStartRecord = null
      }
    }
  },
  mounted () {
    window.addEventListener('focus', this.focusIn)
    window.addEventListener('blur', this.focusOut)
    localStorage.removeItem('DEMO_EDIT')
    if (this.selectScenarioName){
      for (let i in this.chatbots) {
        if (this.chatbots[i].scenario_name == this.selectScenarioName) {
          this.$store.dispatch('chatbot/selectChatbot', this.chatbots[i])
          this.setEditStatus(this.chatbots[i].bot_id, this.user.userHash)
        }
      }
    } else {
      for (let i in this.chatbots) {
        if (this.chatbots[i].scenario_name == this.$route.query.scenario) {
          this.$store.dispatch('chatbot/selectChatbot', this.chatbots[i])
          this.setEditStatus(this.chatbots[i].bot_id, this.user.userHash)
        }
      }
    }
    this.$store.dispatch('chatbot/changeModalAllFalse')
    this.errorCheck(this.scenarioTable)
    document.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('beforeunload', this.onBeforeUnload)
    this.$store.dispatch('auth/getCompanyColumnSetting', null)
    this.everySecond = setInterval(() => {
      this.recordTimeout-=1
    }, 1000);

    // コンポーネント準備OK
    this.$nextTick(() => {
      this.$emit('component-ready', true)
    })
  },
  methods: {
    getIsUp (flg) {
      if (flg) {
        return {'bottom': '0'}
      } else {
        return {'top': '50px'}
      }
    },
    fixURL (text) {
      return text.replace('[url]', '').replace('[/url]', '\n').replace('undefined', '')
    },
    newScenarioTable () {
      let scenarioTable = [...this.scenarioTable]
      for (const i in scenarioTable) {
        if (scenarioTable[i].is_edit) {
          scenarioTable[i].beforenodeX = Math.round(scenarioTable[i].beforenodeX)
          scenarioTable[i].beforenodeY = Math.round(scenarioTable[i].beforenodeY)
        }
      }
      return scenarioTable
    },
    clearIntervalSave () {
      for (const id of this.intervalId) {
        clearInterval(id)
      }
      this.intervalId = []
    },
    openDeleteScenarioList () {
      this.$store.dispatch('chatbot/changeModalDeleteScenarioList')
    },
    openExportRoboPartsSet () {
      this.$store.dispatch('chatbot/changeModalExportRoboPartsSet')
    },
    openImportRoboPartsSet () {
      this.$store.dispatch('chatbot/changeModalImportRoboPartsSet')
    },
    openAllPartsConfirmScenarioList () {
      this.$store.dispatch('chatbot/changeModalAllPartsConfirmScenarioList')
    },
    openSettingArguments () {
      this.$store.dispatch('chatbot/changeModalSettingArguments')
    },
    onDrop (event) {
      // パーツの挿入
      var x = Math.round(event.offsetX * this.$refs.bp.ratio + this.$refs.bp.dx)
      var y = Math.round(event.offsetY * this.$refs.bp.ratio + this.$refs.bp.dy)
      if (x < 0) x = 0
      if (y < 0) y = 0
      this.createScenario(x, y)
      event.preventDefault()

      if (this.dropRoboPartsSet !== null) {
        // パーツセット
        const data = {
          index: -1,
          roboPartsSet: null
        }
        this.$store.dispatch('chatbot/changeIsDropList', data)
      } else {
        // シナリオパーツ
        this.$store.dispatch('chatbot/changeIsDrop', -1)
      }
    },
    onDragover (event) {
      event.preventDefault()
    },
    openHelp () {
      alert('移動：ドラッグ\nズーム：スクロール')
    },
    setChatBot (chatbot) {
      let editIndex = -1
      for (const c in this.chatbots) {
        if (this.chatbots[c].bot_id === chatbot.bot_id) editIndex = c
      }
      this.$store.dispatch('chatbot/setChatBot', this.chatbots[editIndex])
        .then(() => {
          this.$store.dispatch('chatbot/setScenarioTitleBeforeChange', '')
        })
    },
    saveRoboPartsSetName (roboPartsSet) {
      this.$store.dispatch('chatbot/updateRoboPartsSet', roboPartsSet)
        .then(() => {
          this.roboPartsSetNameBeforeChange = ''
        })
    },
    importScenarioList () {
      var scenario_list = JSON.parse(JSON.stringify(this.dropPartsSet.scenario_list))
      // ドロップしたカーソル位置に合わせて全体をずらす
      for (let scenario of scenario_list) {
        scenario['beforenodeX'] = Math.round(scenario['beforenodeX'] + this.importNodeX)
        scenario['beforenodeY'] = Math.round(scenario['beforenodeY'] + this.importNodeY)
      }
      if (this.importNodeX < 0) this.importNodeX = 0
      if (this.importNodeY < 0) this.importNodeY = 0
      this.createScenario(this.importNodeX, this.importNodeY)
      this.$store.dispatch('chatbot/changeIsDrop', -1)
      this.isDropModal = false
      event.preventDefault()
    },
    changeForm (flg) {
      this.isInput = flg
    },
    makeLink (name) {
      return process.env.OWN_ENDPOINT + '/single/demo/' + this.user.companyID + '/' + name
    },
    getRoboLink (botId) {
      const singleURL = process.env.OWN_ENDPOINT + '/single/' + this.user.companyID + '/' + botId
      navigator.clipboard
        .writeText(singleURL)
        .then(() => {
          alert(
            "ロボリンクをコピーしました。"
          );
        })
    },
    createScenario (x, y) {
      if (!this.isRoboPartsSetView) {
        //シナリオ内
        this.sendControlLogRelatedChatBot('シナリオパーツ作成', 'シナリオ編集画面にて、ドラッグ&ドロップでシナリオパーツを新たに作成した。', this.selectChatbot)
      }

      let node = createUUID()

      let createScenarioParts = {
        name: '',
        robo_parts_set: '',
        mainmessage: 'メッセージを記入して下さい',
        beforenode: node,
        beforenodeX: x,
        beforenodeY: y,
        select: [],
        parameter: [],
        status: 0,
        template: '',
        quote_flg: true,
        image: '',
        image_ref: '',
        movie: '',
        movie_ref: '',
        start_flg: false,
        input_flg: false,
        output_flg: false,
        is_edit: true,
        is_cv: false
      }
      let select1 = {
        msg_type: '',
        message: '',
        text_option: '',
        next_node: '',
        point: '0',
      }
      let select2 = {
        msg_type: '',
        message: '',
        text_option: '',
        next_node: '',
        point: '0',
      }
      let ifSelect1 = {
        pointList: [{
          point: 0,
          terms: '',
          reset: false
        }],
        wordList: [{
          word: '',
          terms: '',
          parts: 0
        }],
        random: false
      }
      let ifSelect2 = {
        pointList: [{
          point: 0,
          terms: '',
          reset: false
        }],
        wordList: [{
          word: '',
          terms: '',
          parts: 0
        }],
        random: false
      }
      if (this.isRoboPartsSetView) {
        // パーツセット内
        createScenarioParts.robo_parts_set = this.selectRoboPartsSet.robo_parts_set_id
        createScenarioParts.name = 'parts-set'
      } else {
        // シナリオ内
        createScenarioParts.robo_parts_set = ''
        createScenarioParts.name = this.selectChatbot.scenario_name
      }

      if (this.scenarioPartsIndex === 1) {
        // 選択肢付メッセージ
        select1.msg_type = 'button'
        select1.text_option = 'white'
        select1.message = '選択肢1を入力'
        select2.msg_type = 'button'
        select2.text_option = 'white'
        select2.message = '選択肢2を入力'
        createScenarioParts.select.push(select1)
        createScenarioParts.select.push(select2)
      } else if (this.scenarioPartsIndex === 2) {
        // メッセージのみ
        createScenarioParts.select.push(select1)
        createScenarioParts.status = 2
      } else if (this.scenarioPartsIndex === 4) {
        // ロボ切替
        createScenarioParts.select.push(select1)
        createScenarioParts.parameter = {}
        createScenarioParts.status = 3
      } else if (this.scenarioPartsIndex === 3) {
        // 応募フォーム
        createScenarioParts.select.push(select1)
        createScenarioParts.mainmessage = '[cv][/cv]'
        createScenarioParts.status = 1
        createScenarioParts['parameter'] = {
          disable_email: false,
          default_birth: new Date()
        }
      } else if (this.scenarioPartsIndex === 5) {
        // 日程調整
        createScenarioParts.status = 4
        createScenarioParts.mainmessage = '[calendar][/calendar]'
        createScenarioParts['parameter'] = {
          title: '',
          user_hash: [],
          user_hash_sub: [],
          user_hash_share: [],
          holiday_list: [],
          work_time_start: 9,
          work_time_end: 18,
          interval: 0,
          mtg_time: 1,
          count: 5,
          after: 1,
          period: 0,
          until: 30,
          is_AND: false,
          public_holiday: false,
          mtg_time_hour: 1,
          mtg_time_minute: 0,
          duplicate_num: 0,
          is_all_day: false
        }
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 6) {
        // 画像表示
        createScenarioParts.status = 5
        createScenarioParts.mainmessage = '[image][/image]'
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 7) {
        // 自由入力
        createScenarioParts.status = 6
        createScenarioParts.mainmessage = '[input]メッセージを記入して下さい[/input]'
        createScenarioParts['parameter'] = {
          colomn_name: '設定なし',
          custom_tag: '',
          custom: null,
          input_type: 'free',
          default_birth: new Date(),
          date_type: '',
          apply_flg: false,
          any_flg: false,
          default_flg: false,
          keep_time_hour: 0,
          keep_time_minute: 0
        }
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 8) {
        // ファイルアップロード
        createScenarioParts.status = 7
        createScenarioParts.mainmessage = '[fileupload][/fileupload]'
        createScenarioParts.select.push(select1)
        createScenarioParts['parameter'] = {
          is_resume: false,
          to_google_drive: false
        }
      } else if (this.scenarioPartsIndex === 9) {
        // 履歴書フォーム
        createScenarioParts.status = 8
        createScenarioParts.mainmessage = '[resume][/resume]'
        createScenarioParts.select.push(select1)
        createScenarioParts['parameter'] = {
          image_required: true,
          default_birth: new Date()
        }
      } else if (this.scenarioPartsIndex === 10) {
        // Startに戻る
        if (this.isRoboPartsSetView) {
          alert('パーツセット内には配置できません。')
          return
        }
        createScenarioParts.status = 9
        createScenarioParts.mainmessage = '[restart][/restart]'
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 11) {
        // メール送付
        createScenarioParts.status = 10
        createScenarioParts.mainmessage = 'メール内容を入力'
        createScenarioParts['parameter'] = {
          title: '',
          to: '',
          cc: '',
          after: 0
        }
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 12) {
        // 条件で分ける
        createScenarioParts.status = 12
        createScenarioParts.mainmessage = '条件で分岐させる'
        createScenarioParts.select.push(select1)
        createScenarioParts.select.push(select2)
        createScenarioParts.parameter.push(ifSelect1)
        createScenarioParts.parameter.push(ifSelect2)
      } else if (this.scenarioPartsIndex === 13) {
        // チェック項目
        createScenarioParts.status = 13
        createScenarioParts.mainmessage = '[checkbox][/checkbox]'
        createScenarioParts.parameter.push({item_message: ''})
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 14) {
        // 動画
        createScenarioParts.mainmessage = '[movie][/movie]'
        createScenarioParts['parameter'] = {
          url: '',
          use: 'youtube',
          filename: ''
        }
        createScenarioParts.select.push(select1)
        createScenarioParts.status = 14
      } else if (this.scenarioPartsIndex === 15) {
        // プルダウン選択
        createScenarioParts.mainmessage = '[pulldown]プルダウンから選択してください[/pulldown]'
        createScenarioParts.parameter.push({
          pullDownId      : createUUID(),
          isRequired      : false,
          refPullDownId   : 'None',
          refItemId       : '',
          isLinking       : false,
          title           : '',
          isDispNextTitle : true,
          items           : [{itemId   : createUUID(), itemName : ''}]
        })
        createScenarioParts.select.push(select1)
        createScenarioParts.status = 15
      } else if (this.scenarioPartsIndex === 16) {
        // SMS送付
        createScenarioParts.mainmessage = '送付内容を入力'
        createScenarioParts['parameter'] = {
          to: '',
          after: 0
        }
        createScenarioParts.select.push(select1)
        createScenarioParts.status = 16
      } else if (this.scenarioPartsIndex === 17) {
        // カルーセル
        createScenarioParts.mainmessage = '[carousel][/carousel]'
        createScenarioParts['parameter'] = {
          select1: {id: 1, title: "", contents: "", image_ref: {image_data:"", name:""}, button: ""},
          select2: {id: 2, title: "", contents: "", image_ref: {image_data:"", name:""}, button: ""}
        }
        createScenarioParts.select.push(select1)
        createScenarioParts.select.push(select2)
        createScenarioParts.status = 17
      } else if (this.scenarioPartsIndex === 18) {
        // ファイルダウンロード
        createScenarioParts.mainmessage = '[filedownload]以下からダウンロードしてください。[/filedownload]'
        createScenarioParts.status = 18
        createScenarioParts['parameter'] = {
          filename: [],
          filepaths: [],
          tempfilepath: ''
        }
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 19) {
        // 回答出力
        createScenarioParts.mainmessage = '[output][/output]'
        createScenarioParts.status = 19
        createScenarioParts['parameter'] = {
          format          : 'csv',
          output          : 'mail',
          mail_to         : '',
          user_uuid       : null,
          preserve        : false,
          drive_info      : {
            id        : '',
            name      : '',
            mime_type : '',
            folderPath: []
          },
          file_name       : ''
        }
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 20) {
        // 検索
        createScenarioParts.mainmessage = '[search][/search]'
        createScenarioParts.status = 20
        createScenarioParts['parameter'] = {
          search: [
            {
              keywords   : '',
              type       : 0,
              title      : '',
              description: '',
              url        : '',
              renkeiID   : '',
              image_ref: {
                image_data: '',
                image_id: '',
                name: ''
              },
            }
          ],
          message: '',
          disable_email: false
        }
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 21) {
        // PDFダウンロード
        createScenarioParts.mainmessage = '[pdf-download][/pdf-download]'
        createScenarioParts.status = 21
        createScenarioParts['parameter'] = {
          item_list           : '',
          format_no           : 0,
          file_name           : '',
          send_to             : '',
          attachment_file_name: ''
        }
        createScenarioParts.select.push(select1)
      } else if (this.scenarioPartsIndex === 22) {
        // 付箋パーツ
        createScenarioParts.mainmessage = '[memo][/memo]'
        createScenarioParts.status = 22
      } else if (this.scenarioPartsIndex === 100) {
        // パーツセット
        createScenarioParts.mainmessage = '[parts-set][/parts-set]'
        createScenarioParts.status = 100
        createScenarioParts.robo_parts_set = this.dropRoboPartsSet.robo_parts_set_id
        createScenarioParts['parameter'] = {robo_parts_set_name: this.dropRoboPartsSet.robo_parts_set_name}
      } else {
        // シナリオ以外のドロップは無視
        return 0
      }

      // パーツの保存
      const saveData = {
        companyid: this.user.companyID,
        scenarioName: createScenarioParts.name,
        data: createScenarioParts,
      }
      this.$store.dispatch('chatbot/saveScenario', saveData)
        .then((d) => {
          if (!this.isRoboPartsSetView) {
            this.setCreateStatus(d)
          }
        })
    },
    closeRoboPartsSetView () {
      this.isTemplateReturn = true
      this.$store.dispatch('chatbot/scenarioPastCancel')
      this.$store.dispatch('chatbot/getScenario',
        {
          companyid   : this.user.companyID,
          scenarioName: this.selectScenarioName
        }
      )
      this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + this.selectScenarioName)
    },
    focusOut () {
      this.clearIntervalSave()
    },
    focusIn () {
      if (localStorage.getItem('OTHER_SCE_PASTE_' + this.selectScenarioName) === this.selectScenarioName) {
        // 他のタブかウィンドウでCut & Pasteされていた場合、フォーカスが戻った時にリロードする
        this.$store.dispatch('chatbot/getScenario',
          {
            companyid   : this.user.companyID,
            scenarioName: this.selectScenarioName
          }
        )
        this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + this.selectScenarioName)
        localStorage.removeItem('OTHER_SCE_PASTE_' + this.selectScenarioName)
      }
      if (localStorage.getItem('DEMO_EDIT') === this.selectScenarioName) {
        // デモ画面で編集されていた場合、フォーカスが戻った時にリロードする
        this.$store.dispatch('chatbot/getScenario',
          {
            companyid   : this.user.companyID,
            scenarioName: this.selectScenarioName
          }
        )
        this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + this.selectScenarioName)
        localStorage.removeItem('DEMO_EDIT')
      }
    },
    clickRoboPartsSetName (roboPartsSetName) {
      if (this.roboPartsSetNameBeforeChange == '') {
        this.roboPartsSetNameBeforeChange = roboPartsSetName
      }
    },
    errorCheck (scenarioTable) {
      this.errorList = []
      if (scenarioTable.length) {
        const errorCountList = {
          isStartErrorCount      : this.isStartErrorCount(scenarioTable),
          isGoalErrorCount       : this.isGoalErrorCount(scenarioTable),
          isImageErrorCount      : this.isImageErrorCount(scenarioTable),
          isMovieErrorCount      : this.isMovieErrorCount(scenarioTable),
          isEmailErrorCount      : this.isEmailErrorCount(scenarioTable),
          isSmsErrorCount        : this.isSmsErrorCount(scenarioTable),
          isDownloadErrorCount   : this.isDownloadErrorCount(scenarioTable),
          isChangeRoboErrorCount : this.isChangeRoboErrorCount(scenarioTable),
          isNextRoboErrorCount   : this.isNextRoboErrorCount(scenarioTable),
          isIfErrorCount         : this.isIfErrorCount(scenarioTable),
          isPdfDownloadErrorCount: this.isPdfDownloadErrorCount(scenarioTable),
          isInputErrorCount      : this.isInputErrorCount(scenarioTable),
          isOutputErrorCount     : this.isOutputErrorCount(scenarioTable),
          isIfQuoteErrorCount    : this.isIfQuoteErrorCount(scenarioTable),
          isIfUserInfoErrorCount : this.isIfUserInfoErrorCount(scenarioTable),
          isPdfDownloadErrorCount: this.isPdfDownloadErrorCount(scenarioTable),
        }
        this.createErrorList(errorCountList)
      }
    },
    createErrorList (errorCountList) {
      for (const k in errorCountList) {
        const errorFormat = {
          contents: '',
          solution: ''
        }
        for (let i = 0; i < errorCountList[k]; i++) {
          switch (k) {
            case 'isStartErrorCount':
              errorFormat.contents = '開始設定がされていません。'
              errorFormat.solution = 'シナリオのスタートにしたいパーツを右クリックして開始設定を選択してください。'
              break;
            case 'isGoalErrorCount':
              errorFormat.contents = 'GOAL設定がされていません。'
              errorFormat.solution = '会話完了を取得するシナリオをダブルクリックしてGOALをONに変更してください。'
              break;
            case 'isImageErrorCount':
              errorFormat.contents = '画像が設定されていない画像表示パーツがあります。'
              errorFormat.solution = '該当のパーツをクリックして画像を設定してください。'
              break;
            case 'isMovieErrorCount':
              errorFormat.contents = '動画が設定されていない動画パーツがあります。'
              errorFormat.solution = '該当のパーツをクリックして動画を設定してください。'
              break;
            case 'isEmailErrorCount':
              errorFormat.contents = 'メール送付パーツの宛先が設定されていません。'
              errorFormat.solution = '該当のパーツをクリックしてTO（宛先）を設定してください。'
              break;
            case 'isSmsErrorCount':
              errorFormat.contents = 'SMS送付パーツの宛先が設定されていません。'
              errorFormat.solution = '該当のパーツをクリックしてTEL（宛先）を設定してください。'
              break;
            case 'isDownloadErrorCount':
              errorFormat.contents = 'ファイルダウンロードパーツのファイルが設定されていません。'
              errorFormat.solution = '該当のパーツをクリックしてファイルを設定してください。'
              break;
            case 'isChangeRoboErrorCount':
              errorFormat.contents = 'ロボ切替パーツのロボが設定されていません。'
              errorFormat.solution = '該当のパーツをクリックしてロボを設定してください。'
              break;
            case 'isNextRoboErrorCount':
              errorFormat.contents = 'ロボ切替パーツの選択ロボが確定されていません。'
              errorFormat.solution = '該当のパーツをクリックしてロボを設定してください。'
              break;
            case 'isIfErrorCount':
              errorFormat.contents = '条件で分けるパーツの条件が設定されていません。'
              errorFormat.solution = '該当のパーツをクリックして条件を設定してください。'
              break;
            case 'isIfQuoteErrorCount':
              errorFormat.contents = '条件で分けるパーツの「条件とするパーツ」が存在しないか、到達できません。'
              errorFormat.solution = '該当のパーツをクリックして条件を設定するか、シナリオの接続を確認してください。'
              break;
            case 'isIfUserInfoErrorCount':
              errorFormat.contents = '条件で分けるパーツの「条件とする項目」がロボ引用設定に設定されていません'
              errorFormat.solution = 'ロボ引用設定から当該項目を追加してください。'
              break;
            case 'isPdfDownloadErrorCount':
              errorFormat.contents = 'PDFダウンロードパーツの出力項目が設定されていません。'
              errorFormat.solution = '該当のパーツをクリックして出力項目を設定してください。'
              break
            case 'isInputErrorCount':
              errorFormat.contents = 'パーツセットに入力パーツが設定されていません。'
              errorFormat.solution = '該当のパーツをクリックして入力設定してください。'
              break
            case 'isOutputErrorCount':
              errorFormat.contents = 'パーツセットに出力パーツが設定されていません。'
              errorFormat.solution = '該当のパーツをクリックして出力設定してください。'
              break
          }
          this.errorList.push(errorFormat)
        }
      }
      this.checkViewingError()
    },
    isStartErrorCount (scenarioTable) {
      if (!this.isRoboPartsSetView) {
        if (scenarioTable.filter(v => v.start_flg).length) return 0
        else return 1
      } else {
        return 0
      }
    },
    isGoalErrorCount (scenarioTable) {
      if (!this.isRoboPartsSetView) {
        if (scenarioTable.filter(v => v.is_cv).length) return 0
        else return 1
      } else {
        return 0
      }
    },
    isImageErrorCount (scenarioTable) {
      return scenarioTable.filter(v => v.status == 5 && v.image === '' ).length
    },
    isMovieErrorCount (scenarioTable) {
      return scenarioTable.filter(v => v.status == 14 && v.parameter.filename === '' && v.parameter.url === '').length
    },
    isEmailErrorCount (scenarioTable) {
      return scenarioTable.filter(v => v.status == 10 && v.parameter.to === '').length
    },
    isSmsErrorCount (scenarioTable) {
      return scenarioTable.filter(v => v.status == 16 && v.parameter.to === '').length
    },
    isDownloadErrorCount (scenarioTable) {
      return scenarioTable.filter(v => v.status == 18 && !v.parameter.filename.length).length
    },
    isChangeRoboErrorCount (scenarioTable) {
      return scenarioTable.filter(v => v.status == 3 && !("bot_id" in v.parameter)).length
    },
    isNextRoboErrorCount (scenarioTable) {
      let errorCount = 0
      const parameters = scenarioTable.filter(v => v.status == 3).map(v => v.parameter)
      for (const parameter of parameters) {
        for (const c of this.chatbots) {
          if (parameter.bot_id == c.bot_id) {
            if (!c.is_confirm) {
              errorCount++
              break
            }
          } 
        }
      }
      return errorCount
    },
    isIfErrorCount (scenarioTable) {
      // 条件で分けるはrandomを選択しておらず、ポイント、ワード、応募者情報、ミニロボ変数のどれもtermsを登録してない場合に条件が設定されていないエラーを出す
      let errorCount = 0
      const parameters = scenarioTable.filter(v => v.status == 12).map(v => v.parameter)
      for (const parameter of parameters) {
        // セッション切替の場合はスキップ
        if (parameter.length > 0 && parameter[0].sessionSwitch === true) {
          continue
        }
        // セッション切替の別判定：すべての条件が未設定かつrandomでない場合
        // （セッション切替では条件設定が不要なため）
        if (parameter.length > 0 && !parameter[0].random) {
          const p = parameter[0]
          const isAllEmpty = 
            p.pointList.every(pl => pl.terms === '') &&
            p.wordList.every(wl => wl.terms === '') &&
            (!p.userInfoList || p.userInfoList.every(ul => ul.terms === '')) &&
            (!p.miniroboVarsList || p.miniroboVarsList.every(ml => ml.terms === ''))
          
          // すべての条件が空の場合はセッション切替として扱い、スキップ
          if (isAllEmpty) {
            continue
          }
        }
        for (const p of parameter.filter(v => !v.random)) {
          let isNotPoint = false
          let isNotWord = false
          let isNotUserInfo = false
          let isNotMiniRobo = false
          for (const pointList of p.pointList) {
            if (pointList.terms === '') isNotPoint = true
          }
          for (const wordList of p.wordList) {
            if (wordList.terms === '') isNotWord = true
          }
          if (p.userInfoList) {
            for (const userInfoList of p.userInfoList) {
              if (userInfoList.terms === '') isNotUserInfo = true
            }
          }
          else {
            isNotUserInfo = true
          }
          if (p.miniroboVarsList) {
            for (const miniroboVarsList of (p.miniroboVarsList || [])) {
              if (miniroboVarsList.terms === '') isNotMiniRobo = true
            }
          }
          else {
            isNotMiniRobo = true
          }
          if (isNotPoint && isNotWord && isNotUserInfo && isNotMiniRobo) {
            errorCount++
            break
          }
        }
      }
      return errorCount
    },
    isIfQuoteErrorCount (scenarioTable) {
      // 「条件とするパーツ」が存在しない or 到達できないならエラー
      let errorCount = 0

      const next_nodes = {}
      for (let scenario of scenarioTable) next_nodes[scenario.beforenode] = scenario.select.filter(sel => sel.next_node).map(sel => sel.next_node)

      const start_scenario = scenarioTable.find(s => s.start_flg)
      if (!start_scenario) return 0
      const start_node = start_scenario.beforenode

      const end_nodes = scenarioTable.filter(scenario => scenario.is_cv).map(scenario => scenario.beforenode)

      //開始ノードから各ノードへ、必ず通るノードを集計
      //スタートへ戻ってくるパスとゴールから先のパスは考慮しない
      let route = {[start_node]: []}
      let queue = [start_node]
      while(queue.length!=0) {
        const node = queue.shift()
        if (end_nodes.includes(node)) continue
        if (!(node in next_nodes)) continue
        for (const next of next_nodes[node]) {
          const temp_route = [node].concat(route[node])
          if (!(next in route)) {
            route[next] = temp_route
            queue = queue.filter(n => n!=next)
            queue.push(next)
          }
          else {
            const pre_size = route[next].length
            route[next] = route[next].filter(n => temp_route.includes(n))
            if (pre_size != route[next].length) {
              queue = queue.filter(n => n!=next)
              queue.push(next)
            }
          }
        }
      }
      const if_scenarios = scenarioTable.filter(v => v.status == 12 && v.parameter[0].wordList[0].terms)

      //開始ノードから当該分岐パーツまでの間に、必ず「条件とするパーツ」が含まれるかどうか
      for (const if_scenario of if_scenarios) {
        const if_node = if_scenario.beforenode
        if (!route[if_node]) continue
        for (let param of if_scenario.parameter) {
          if (!Number(param.wordList[0].parts)) continue
          const target_scenario = scenarioTable.find(scenario => scenario.pk == param.wordList[0].parts)
          if (!target_scenario) {errorCount++;break}
          const target_node = target_scenario.beforenode
          if (!route[if_node].includes(target_node)) {errorCount++;break}
        }
      }

      return errorCount
    },
    isIfUserInfoErrorCount (scenarioTable) {
      // 「条件とする項目」がロボ引用設定に設定されていない場合エラー
      let errorCount = 0
      const parameters = scenarioTable.filter(v => v.status == 12).map(v => v.parameter)
      for (const parameter of parameters) {
        if (!parameter[0].userInfoList || parameter[0].userInfoList[0].terms === '') continue
        for (const p of parameter) {
          if (!this.selectChatbot.robo_arguments.map(column => column.pk).includes(p.userInfoList[0].column_pk)) {
            errorCount++
            break
          }
        }
      }
      return errorCount
    },
    isPdfDownloadErrorCount (scenarioTable) {
      return scenarioTable.filter(v => v.status == 21 && v.parameter.item_list === '').length
    },
    isInputErrorCount (scenarioTable) {
      if (this.isRoboPartsSetView) {
        if (scenarioTable.filter(v => v.input_flg).length) {
          return 0
        } else {
          return 1
        }
      } else {
        return 0
      }
    },
    isOutputErrorCount (scenarioTable) {
      if (this.isRoboPartsSetView) {
        if (scenarioTable.filter(v => v.output_flg).length) {
          return 0
        } else {
          return 1
        }
      } else {
        return 0
      }
    },
    changeIsErrorFooter (bool) {
      this.isErrorFooter = bool
    },
    minusErrorItemNumber (i) {
      if (this.errorItemNumber >= 1) {
        this.changeErrorItemNumber(i)
      } else {
        this.changeErrorItemNumber(this.errorList.length - 1)
      }
    },
    plusErrorItemNumber (i) {
      if (this.errorItemNumber < this.errorList.length - 1) {
        this.changeErrorItemNumber(i)
      } else {
        this.changeErrorItemNumber(-this.errorList.length + 1)
      }
    },
    checkViewingError () {
      if (this.errorList.length === this.errorItemNumber) this.changeErrorItemNumber(-1)
    },
    changeErrorItemNumber (i) {
      this.errorItemNumber += i
    },
    setEditStatus (botID, userHash) {
      // ロボの編集情報を送信
      let editData = {
        'uuid'       : userHash,
        'bot_id'     : botID,
        'scenario_id': null,
      }
      this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
        '[SETSCENARIO]' + JSON.stringify(editData)
      )
    },
    isOnUser (user) {
      return user.editChatBot === this.selectChatbot.bot_id
    },
    setCreateStatus (scenario) {
      // ロボの編集情報を送信
      this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
        '[CREATESCENARIO]' + JSON.stringify(scenario)
      )
    },
    undoScenario () {
      if (this.currentUndoIndex >= (this.undoData.length -1)) {
        alert('これ以上戻れません。')
        return
      }
      this.$store.dispatch('chatbot/undoScenario', {companyid: this.user.companyID, scenarioName: this.selectScenarioName})
        .then(() => {
          // 他のアカウントと同編集のばあいはリロードを促す
          this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
            '[RELOADSCENARIO]' + this.selectScenarioName
          )
        })
    },
    redoScenario () {
      if (this.currentUndoIndex <= 0) {
        alert('これ以上取り消せません。')
        return
      }
      this.$store.dispatch('chatbot/redoScenario', {companyid: this.user.companyID, scenarioName: this.selectScenarioName})
        .then(() => {
          // 他のアカウントと同編集のばあいはリロードを促す
          this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
            '[RELOADSCENARIO]' + this.selectScenarioName
          )
        })
    },
    /** 操作フラグクリア */
    clearOpeInfo () {
      this.isTemplateReturn = false
    },
    /** GOAL設定エラーチェック */
    checkGoalErrorCount () {
      // 親コンポーネントから呼ばれるGOAL設定エラーチェック
      let cnt = 0
      if (!this.isTemplateReturn) {
        // テンプレートビューから戻るとき以外
        cnt = this.isGoalErrorCount(this.scenarioTable)
      }
      if (cnt === 0) {
        // GOAL設定エラーなし
        this.isGoalError = false
      } else {
        // GOAL設定エラーあり
        this.isGoalError = true
      }
      this.$emit('return-goal-error-count', this.isGoalError)
    },
    onMouseMove () {
      if (this.recordTimeout < 0) {
        //開始時 or タイムアウト後
        this.editStartRecord = {chatbot_id: this.selectChatbot.bot_id, start: new Date()}
      }
      if (this.recordTimeout != 0) this.recordTimeout = 60
    },
    onBeforeUnload () {
      if (this.editStartRecord && this.recordTimeout > 0) {
        this.$store.dispatch('chatbot/saveScenarioEditLog', {
          chatbot_id: this.editStartRecord.chatbot_id,
          time_sec: (new Date().getTime() - this.editStartRecord.start.getTime()) / 1000
        })
      }
    },
    searchPartsConfirm (scenario) {
      for (var s of scenario) {
        if (!s.is_confirm) {
          return true
        }
      }
      return false
    },
    checkAuthority () {
      return isRoboDisplayPermission(this.selectChatbot, this.user)
    },
    openChatBotPreview (chatbot) {
      const url = process.env.OWN_ENDPOINT + '/single/demo/' + chatbot.group + '/' + chatbot.scenario_name
      const h = window.outerHeight
      const w = window.outerWidth / 2
      window.open(url, '_blank', 'width=' + w + 'px, height=' + h + 'px, left=0, top=0, directories=no, status=no, menubar=no, scrollbars=yes, location=no, toolbar=no')
    },
    changeByParts (scenario) {
      this.$store.dispatch('chatbot/changeModalEditScenario')
      if (scenario) {
        this.$store.dispatch('chatbot/confirmByParts', scenario)
      }
      //this.cancel()
    },
  },
  beforeDestroy () {
    clearTimeout(this.everySecond)
    document.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('beforeunload', this.onBeforeUnload)
    if (this.editStartRecord && this.recordTimeout > 0) {
      this.$store.dispatch('chatbot/saveScenarioEditLog', {
        chatbot_id: this.editStartRecord.chatbot_id,
        time_sec: (new Date().getTime() - this.editStartRecord.start.getTime()) / 1000
      })
    }
    this.setEditStatus(null, this.user.userHash)
    this.clearIntervalSave()
    localStorage.removeItem('DEMO_EDIT')
    localStorage.removeItem('OTHER_SCE_PASTE_' + this.selectScenarioName)
    window.removeEventListener('focus', this.focusIn)
    window.removeEventListener('blur', this.focusOut)
    this.$emit('component-ready', false)
  },
  countConfirmAll (scenario) {
    let count = 0
    for (var s of scenario) {
      if (s.is_confirm) {
        count += 1
      }
    }
    return count
  },
}
</script>

<style lang="scss" scoped>
.scenario-table-template {
  background: rgba(0, 0, 0, 0.15);
}
.scenario-table {
  width: 100%;
  height: calc(100vh - 60px);
  display: block;
  overflow: hidden;
  .header-scenario {
    display: flex;
    height: 50px;
    overflow: hidden;
    border-bottom: solid thin #ccc;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    .header-scenario-template {
      background: rgba(0, 0, 0, 0.15);
    }
    .header-button-list {
      display: flex;
      justify-content: space-between;
      width: 30%;
    }
    .header-title {
      width: 50%;
      span {
        width: 100%;
      }
    }
    .header-status {
      width: 20%;
      padding: 4px;
      height: 50px;
      border-left: solid thin #ccc;
      display: flex;
      align-items: center;
      /deep/ .user-icon {
        margin-top: 5px;
        margin-left: 4px;
        height: 45px;
        width: 45px;
        object-fit: contain;
        border-radius: 50%;
        border: solid thin #ccc;
      }
    }
    .scenario-title {
      font-size: 14px;
      font-weight: 700;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-left: 8px;
      height: 100%;
    }
  }
  .scenario-flow-height {
    height: calc(100vh - 110px);
  }
  .scenario-flow-parts-set-height {
    height: calc(100vh - 90px);
  }
  .scenario-flow {
    display: flex;
    position: relative;
    transition: 0.5s;
    cursor : -webkit-grab;
    cursor : -moz-grab;
    cursor : -o-grab;
    cursor : grab;
    .hukidashi-width {
      width: calc(100% - 670px);
    }
    .hukidashi-thin-menu-width {
      width: calc(100% - 518px);
    }
    .hukidashi {
      position: fixed;
      height: 160px;
      padding: 8px;
      text-align: left;
      background: rgba(0, 0, 0, 0.8);
      border: solid 2px #222;
      top: calc(100vh - 235px);
      color: #f8f8f8;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      animation: slideIn .7s;
    }
  }
  .scenario-flow:active {
    cursor : -webkit-grabbing;
    cursor : -moz-grabbing;
    cursor : -o-grabbing;
    cursor : grabbing;
  }
  @keyframes slideIn {
    0% {
      opacity: 0;
      transform: translateY(200px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .message-box {
    margin-left: 20px;
    height: 120px;
    width: calc(100% - 160px);
    border: solid 3px white;
    border-radius: 16px;
    border-top-left-radius: 0px;
    text-align: left;
    padding: 7.5px 10px;
    transition: 0.5s;
  }
  .message-detail {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
  .svg-button {
    color: #f8f8f8;
  }
  .svg-button:hover {
    color: #ccfff2;
  }
  .on-drop-area {
    border: dashed 3px #ccc;
  }
  .drop-filter {
    position: absolute;
    width: 5000vw;
    height: 5000vh;
    background: #ccfff2;
    opacity: 0.5;
    padding-top: 20%;
  }
  .map-filter {
    position: absolute;
    width: 10vw;
    height: 10vh;
    background: #ccfff2;
    opacity: 0.5;
    bottom: 0;
  }
  .drop-filter-ghost {
    position: absolute;
    height: 200px;
    width: 200px;
    opacity: 1;
    padding-top: 20%;
    z-index: 100;
  }
  .drop-filter > p {
    font-size: 24px;
    font-weight: 600;
    opacity: 1;
  }
  .tooltip{
    position : relative;
    cursor   : pointer;
    display  : inline-block;
  }
  .tooltip-mail {
    display       : none;
    position      : absolute;
    color         : #fff;
    background    : #363636;
    padding       : 8px;
    font-size     : 14px;
    border-radius : 5px;
    width         : 100px;
    z-index       : 10;
  }
  .tooltip-mail:before {
    content    : "";
    position   : absolute;
    top        : -20px;
    left       : 5px;
    border     : 15px solid transparent;
    border-top : 15px solid #363636;
    transform  : rotateZ(180deg);
  }
  .tooltip:hover .tooltip-mail{
    display : inline-block;
    top     : 34px;
    left    : 0px;
  }
  .save-title-button {
    justify-content: space-between;
    padding: 0;
    padding-left: 5px;
    padding-right: 5px;
    z-index: 5;
  }
}
.footer-button {
  width: 100%;
}
.scenario-table:focus {
  outline: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ScenarioList.vue